import NewReferralMailInvite from './NewReferralMailInvite';
export default NewReferralMailInvite;
